import React, { Component } from 'react';
import { ApiGetInviteCode } from '@/api/';
import { copyToClip, getProxyConfig } from '@/utils/utils';
import { Toast } from 'antd-mobile';
import PriceMsg from '../map'

class InviteCode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inviteCode: '',
      inviteText: '',
      canShare: true,
    }
  }

  getSmsContent () {
    const { inviteCode } = this.state;
    const { app } = this.props;
    return `${ window.location.origin }/h5/register/${ app }?inviteCode=${ inviteCode }`
  }

  clickCopy () {
    copyToClip(this.state.inviteCode); // 复制内容
    const msg = (PriceMsg[this.props.app] && PriceMsg[this.props.app].copySuccess) || PriceMsg['default'].copySuccess
    Toast.info(msg, 3);
  }

  getCode () {
    this.setState({ canShare: false });

    const { app, appRules, appData } = this.props;
    let [iv, text] = ['', ''];
    ApiGetInviteCode({
      headers: {
        ...appRules.header,
        ...appData,
      },
      ...getProxyConfig(app),
    }).then(res => {
      iv = res.inviteCode || '';
      text = res.inviteText || ''
    }).finally(() => {
      this.setState({
        inviteCode: iv,
        inviteText: text,
        canShare: true,
      })
      this.emit();
    })
  }

  emit () {
    this.props.onChange(this.state);
  }

  componentDidMount() {
    this.getCode();
  }

  render() {
    const { app } = this.props;

    const { inviteCode } = this.state
    return <div className="log-box invite-code">
      <h2 className="log-box-title">{ (PriceMsg[app] && PriceMsg[app].inviteMsg) || PriceMsg['default'].inviteMsg }</h2>
      <div className="log-box-content" onClick={() => this.clickCopy() }>
        <h3 className="title">{ (PriceMsg[app] && PriceMsg[app].inviteCode) || PriceMsg['default'].inviteCode }</h3>
        <div className="code">{ inviteCode }</div>
        <p className="title">{ (PriceMsg[app] && PriceMsg[app].copy) || PriceMsg['default'].copy }</p>
      </div>
    </div>
  }
}

export default InviteCode;
